import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroupDirective, ControlContainer } from '@angular/forms';
import { MonacoEditorLoaderService } from '@materia-ui/ngx-monaco-editor';
import { filter, take } from 'rxjs/operators';

//https://materiahq.github.io/ngx-monaco-editor/api-reference/index.html
//https://stackoverflow.com/questions/51359689/monaco-editor-registercompletionitemprovider-removes-the-default-local-variable
//https://gist.github.com/mwrouse/05d8c11cd3872c19c684bd1904a2202e
//https://microsoft.github.io/monaco-editor/monarch.html
@Component({
  selector: 'monaco-liquid-editor',
  templateUrl: './monaco-liquid-editor.component.html',
  styleUrls: ['./monaco-liquid-editor.component.css'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class MonacoLiquidEditorComponent implements OnInit {

  @Input()
  theme = 'vs-dark';

  @Input()
  language = 'html';

  @Output()
  onInitEvent = new EventEmitter<any>();

  editorOptions: {};

  @Input()
  editorForm: any; // formControlName

  private monaco: any;

  constructor(private readonly monacoLoaderService: MonacoEditorLoaderService) {
    let isInitialized = false;
    this.monacoLoaderService.isMonacoLoaded$.pipe(
      filter(isLoaded => isLoaded),
      take(1),
    ).subscribe((loaded) => {
      if (!isInitialized) {
        this.monaco = (<any>window).monaco;
        if (this.monaco && (this.language === 'liquid' || this.language === 'html')) {
          isInitialized = true;
          this.registerAutocompleteProvider(this.monaco);
        }
      }
    });
  }

  ngOnInit() {
    if (!this.language) {
      this.language = 'html';
    }
    this.editorOptions = { theme: this.theme, language: this.language };
  }

  editorInit(editor) {
    editor.tabCompletion = 'on';
    this.onInitEvent.emit(editor);
  }

  private registerAutocompleteProvider(monaco) {
    //monaco.languages.register({ id: 'liquid' });
    monaco.languages.registerCompletionItemProvider('html', {
      provideCompletionItems: () => {
        var autocompleteProviderItems = [];
        var keywords = ['assign', 'capture', 'endcapture', 'increment', 'decrement',
          'if', 'else', 'elsif', 'endif', 'for', 'endfor', 'break',
          'continue', 'limit', 'offset', 'range', 'reversed', 'cols',
          'case', 'endcase', 'when', 'block', 'endblock', 'true', 'false',
          'in', 'unless', 'endunless', 'cycle', 'tablerow', 'endtablerow',
          'contains', 'startswith', 'endswith', 'comment', 'endcomment',
          'raw', 'endraw', 'editable', 'endentitylist', 'endentityview', 'endinclude',
          'endmarker', 'entitylist', 'entityview', 'forloop', 'image', 'include',
          'marker', 'outputcache', 'plugin', 'style', 'text', 'widget',
          'abs', 'append', 'at_least', 'at_most', 'capitalize', 'ceil', 'compact',
          'concat', 'date', 'default', 'divided_by', 'downcase', 'escape',
          'escape_once', 'first', 'floor', 'join', 'last', 'lstrip', 'map',
          'minus', 'modulo', 'newline_to_br', 'plus', 'prepend', 'remove',
          'remove_first', 'replace', 'replace_first', 'reverse', 'round',
          'rstrip', 'size', 'slice', 'sort', 'sort_natural', 'split', 'strip',
          'strip_html', 'strip_newlines', 'times', 'truncate', 'truncatewords',
          'uniq', 'upcase', 'url_decode', 'url_encode'];

        for (var i = 0; i < keywords.length; i++) {
          autocompleteProviderItems.push({ 'label': keywords[i], kind: monaco.languages.CompletionItemKind.Keyword });
        }

        return { suggestions: autocompleteProviderItems };
      }
    });
  }
}
